// extracted by mini-css-extract-plugin
export var numpadContainer = "_jq-1";
export var phoneButton = "_jq-0";